import { useTranslation } from 'react-i18next';

import './TrackerChallengeBox.css';

function TrackerChallengeBox() {
  const { t } = useTranslation();
  return (
    <div className="tracker-challenge">
      <div className="tracker-challenge-heading">{t('challenge.tracker.active.title')} </div>
      <div className="tracker-challenge-body">{t('challenge.tracker.active.description')}</div>
    </div>
  );
}

export default TrackerChallengeBox;
